// extracted by mini-css-extract-plugin
export default {"form":"classes_form__iRl-D","form-container":"classes_form-container__VUrF+","button-container":"classes_button-container__oCRpg"};